import { createContext, useContext } from 'react';
import { getClientParameters } from './api';
import { PlaidLinkConfig } from '../shared/constants/clientConstants';
import { useMockPlaidLink } from '../utils/plaidLink.js';
import { usePlaidLink as useLivePlaidLink } from 'react-plaid-link';
import { useAsync } from '../components/common/commonHooks.js';

const AppConfigContext = createContext();

const AppConfigProvider = ({ children }) => {
  const clientParameters = useAsync(getClientParameters);
  return <AppConfigContext.Provider value={{ clientParameters }}>{children}</AppConfigContext.Provider>;
};

const useClientParams = () => {
  const { clientParameters } = useContext(AppConfigContext);
  return clientParameters;
};

const useConfiguredPlaidLink = (...args) => {
  const { clientParameters } = useContext(AppConfigContext);

  const useNotReadyPlaidLink = () => ({ ready: false, open: false });

  const usePlaidLink =
    clientParameters?.plaidLink === PlaidLinkConfig.LIVE
      ? useLivePlaidLink
      : clientParameters?.plaidLink === PlaidLinkConfig.MOCK
      ? useMockPlaidLink
      : useNotReadyPlaidLink;

  return usePlaidLink(...args);
};

export { AppConfigProvider, useClientParams, useConfiguredPlaidLink };
